{
  "data": {
    "from": "2026-04-08T03:00:00.000Z",
    "to": "2026-04-09T02:59:59.999Z",
    "stationIds": [
      "8e2734f9-137b-4a10-b04b-a962a97ed535",
      "2ceeaaaa-7699-489b-b265-413aefe97052",
      "40a4ca77-4d6d-4e46-9302-971af24a2f58",
      "b226d7d4-1c6e-458f-a399-48afc5ccb654",
      "a4cd600a-c026-4903-a96f-48b745e34ce1",
      "6a40f6d0-17ac-4d22-a4aa-e8d3bc3122e2",
      "dc3ccdc4-3752-4632-97fa-55d73cab5be7",
      "b6fe7d10-2606-4d5b-bfa3-77f05586105a",
      "5ac4fc76-97c7-47ff-8431-64be84f93979",
      "88e231cc-deb5-48dd-89a5-c9455e922c9c",
      "112e45b7-bd75-4475-8d70-c6db9d2fec74",
      "09a45b9b-abe6-4fb7-b267-d94ceaa424d5",
      "15f719ee-dd3c-4728-b14b-77232342431f",
      "1660eafe-70d8-42ab-8a57-8cfa5ed290c0",
      "1712b992-cdc0-4d31-81b3-cad376d90290",
      "9dd15485-dc2b-458e-9036-f6674d03f8c3",
      "90eaa83a-2e19-451d-8fe4-cfc5c5f94e5e",
      "45607b72-f8e6-43db-960a-31afa4686a2c",
      "63eb7fbc-7969-41ee-b6d9-bc61ffe60467",
      "954ed8b4-3811-4e01-82b4-6ee102ec1c4e",
      "00350dae-1212-4a06-a9b6-38507b426872",
      "7e25d718-1b35-4796-ab8f-64a462ca36f8",
      "0a25fdd4-c75e-44f7-b824-814e3da1a76b",
      "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
      "6b2b62f7-32f6-4400-a47e-9a4f8d4072a5",
      "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
      "6f005d02-a104-4c07-b8d4-961d1d853aa2",
      "bc8f11ab-d90c-4608-86fe-e3b0d60c5dc6",
      "f81022b3-c233-462e-9b76-60bac92a4d01",
      "517193e9-b611-4988-aab5-f476af178ae6",
      "4436d1ea-ebc6-46c2-9b3c-412d37452163",
      "197923e4-e094-4789-b032-95ce33230c60",
      "b01411c7-fcd4-4ab2-9ae2-a753e63c2a77",
      "ddd952d0-2511-4a2c-8a37-0d58ea6dc0c6",
      "6070c7cd-40eb-4980-8cb7-67f0193bd480",
      "11c173c5-e9f5-447b-aa26-6fa2f2392d8e",
      "d12d5514-5c13-46d8-9da6-8077d9930b9c",
      "e6592d8c-e789-4ef2-9a20-bd41ec3d88f2",
      "eabe3234-5036-4f0b-a1df-1d014f1a7fe4",
      "71d7f5d0-9e14-443c-91b0-e0b31fc7b29c",
      "e84ef14e-e3c3-437f-a64c-531d82b262f8",
      "7cd766b9-2f9d-456a-a25b-d4231afad1ce",
      "61f3d8a0-286c-4645-8b14-8620116f6808",
      "10e19537-7f15-4893-a391-2d375aa8acb5",
      "cac8937d-efff-4395-8a69-f42ff538fe26",
      "0830accd-339d-43ec-a399-f880f1b59bbc",
      "e291db92-ec09-4b0f-b12b-3585d210ff45",
      "764d89e5-501e-40b4-940b-6a14f330dc81",
      "b948f433-5648-4eb0-811f-8b88d968c640",
      "0cd5a15a-4f03-4b6d-93b8-636822fee99c",
      "4f92e971-ce03-47b0-9edc-4171c2087687",
      "0184acf2-4325-4066-a7da-2f2add4c7c2b",
      "d8796c12-74bd-468c-b8d1-69a3d7588ce3",
      "ab9eeb03-84cb-455f-a3d2-941572aa521b",
      "d40cf229-fe05-4ea1-888a-084b81cef618",
      "86693a78-4546-4f5a-97cf-26976d1d9644",
      "99991d50-0299-4b2c-b39e-173382c497fc",
      "92115aa7-9681-4343-b039-05158ba80a30",
      "d797fa66-a853-42a5-b2d1-572c0aab1303",
      "ad94077d-651f-4e07-9fe4-a57588e81434",
      "05c9865e-2f70-4121-9e58-42c0c6d390b7",
      "f3c7e78f-aee2-47bc-b152-e982a7eaf9b2",
      "04ba892b-58a6-4f2a-ad1f-69771c647a80",
      "d7330340-669b-4b18-b7ce-05fe1e9a3fdc",
      "9a2a8c10-4ddd-48b1-8623-7a7bd56fb1d2",
      "ff96cadf-007e-4053-911e-f3d2484b6579",
      "e7837317-8314-4c38-bd4b-8f263f5545cd",
      "27799eab-464d-40cf-ac4d-157a73684ab4",
      "f4c3ce17-a186-46fb-bbe1-81257f9c2b6a",
      "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
      "2b1df331-160d-4948-b26e-7d3798c79559",
      "677ca85a-33e6-4cc4-a004-88ee741dd4ab",
      "6031e0d1-fa7d-4ff5-9931-5d305a530e5c",
      "645a0be6-a451-4932-bad1-0e27ffb01f42",
      "fce78082-619b-4fa0-b01b-e63da0cacf3e",
      "7acfa578-c92a-4cc1-b8dd-09856ca90e6d",
      "192cd181-ae2d-461a-8d2b-8844fe1ef090",
      "42eff9b9-2864-48cc-bc82-5a72cc67d619",
      "4aa656e2-fd41-4aff-a6d7-59713f288582",
      "1098631f-11ba-41b6-b5ff-7dcc3f10a5b8",
      "d1b14752-cefc-4079-98f1-674d3e14e80f",
      "e9161ab9-f457-405b-a272-9eca7d6c1d9a",
      "0bea368f-d27a-4c63-a656-8598414b7bd1",
      "c8c3be17-339e-4563-914f-7cd64817d9f4",
      "37cd7cdc-ec7c-4a8f-985a-0c4dc5b9084a",
      "019c0a25-b502-47c1-86a5-5be9435d8eef",
      "2e40c74f-3f86-4ab7-bd8c-4db495531396",
      "9aca0b22-eebc-4c6c-a171-d6209be0fce5",
      "09ebb340-7007-4ccf-9742-3d9dca59c431",
      "bbd64e88-05da-4f39-a1a6-9a90932fb052",
      "948ed131-ea21-4369-8d87-b17c314de7c3",
      "546ddf5d-9db2-4ff5-a5e2-ecd0da990959",
      "0ced609a-bcfd-40ca-80dc-37b5f7726caf",
      "284f240c-e40d-44f7-a703-8d538cfb9af8",
      "25033d4b-92bf-40b1-994b-fcf06983fc97",
      "c9f4aff8-55f0-4f7e-942b-e5bc6b798c26",
      "298f9893-4684-4d7a-b377-26054de56458",
      "ad59d52e-991b-4b01-8d97-dec9a1c0c84b",
      "01e00cc6-95d2-4ef8-b343-6a3d1c1d9cb6",
      "cf56afae-a35f-4a57-a01a-80144694981c",
      "f722157e-bac3-4bbd-91d4-05cd0fcfe725",
      "a01ad234-9b34-460b-9ce9-268423e5d4a9"
    ],
    "stationsFilters": []
  },
  "result": {
    "stats": {
      "kpis": {
        "continuity": {
          "incidentCount": 27,
          "incidentDurationSeconds": 3650.711,
          "maxIncidentDurationSeconds": 1064.96,
          "meanIncidentDurationSeconds": 135.21151851851852,
          "affectedStationsCount": 4,
          "affectedStationsRate": 0.0392156862745098,
          "uptimeRatio": 0.9995857490193522,
          "downtimeRatio": 0.0004142509806478758
        },
        "quality": {
          "silentIncidentCount": 15,
          "silentDurationSeconds": 57034,
          "poorQualityIncidentCount": 0,
          "poorQualityDurationSeconds": 0,
          "totalIncidentCount": 15,
          "totalDurationSeconds": 57034,
          "affectedStationsCount": 11,
          "affectedStationsRate": 0.10784313725490197,
          "degradationRatio": 0.006471723023342837
        },
        "serviceHealth": {
          "weightedBadSeconds": 60642.710999999996,
          "globalUptimeRatio": 0.9931187917912714,
          "healthScoreRatio": 0.9931187917912714
        }
      },
      "totalStations": 102,
      "stationsWithAnyIssueCount": 17,
      "stationsWithoutIssuesCount": 85,
      "totalStreamGaps": 30,
      "totalStreamGapDurationSeconds": 3650.711,
      "averageStreamGapDurationSeconds": 121.69036666666666,
      "maxStreamGapDurationSeconds": 1064.96,
      "totalAudioIssues": 57,
      "totalAudioIssueDurationSeconds": 56992,
      "silentIssuesCount": 57,
      "poorQualityIssuesCount": 0,
      "silentIssueDurationSeconds": 56992,
      "poorQualityIssueDurationSeconds": 0,
      "affectedStationRate": 0.16666666666666666
    },
    "byStation": [
      {
        "stationId": "8e2734f9-137b-4a10-b04b-a962a97ed535",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "2ceeaaaa-7699-489b-b265-413aefe97052",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "2ceeaaaa-7699-489b-b265-413aefe97052",
            "kind": "silent",
            "start": "2026-04-08T04:01:04Z",
            "end": "2026-04-08T04:09:04Z",
            "durationSeconds": 480,
            "avgSilenceRatio": 0.9776306349440709,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 480,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 480,
              "degradationRatio": 0.005555555619855968
            },
            "serviceHealth": {
              "weightedBadSeconds": 480,
              "stationUptimeRatio": 0.994444444380144,
              "healthScoreRatio": 0.994444444380144
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 1,
          "silentIssueDurationSeconds": 480
        }
      },
      {
        "stationId": "40a4ca77-4d6d-4e46-9302-971af24a2f58",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "b226d7d4-1c6e-458f-a399-48afc5ccb654",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "a4cd600a-c026-4903-a96f-48b745e34ce1",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "6a40f6d0-17ac-4d22-a4aa-e8d3bc3122e2",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "dc3ccdc4-3752-4632-97fa-55d73cab5be7",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "b6fe7d10-2606-4d5b-bfa3-77f05586105a",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
            "kind": "silent",
            "start": "2026-04-08T05:03:54Z",
            "end": "2026-04-08T05:37:53Z",
            "durationSeconds": 2039,
            "avgSilenceRatio": 0.9991586833928634,
            "avgQualityScore": null
          },
          {
            "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
            "kind": "silent",
            "start": "2026-04-08T05:37:54Z",
            "end": "2026-04-08T07:07:52Z",
            "durationSeconds": 5398,
            "avgSilenceRatio": 1.0000005000898509,
            "avgQualityScore": null
          },
          {
            "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
            "kind": "silent",
            "start": "2026-04-08T07:07:53Z",
            "end": "2026-04-08T08:44:51Z",
            "durationSeconds": 5818,
            "avgSilenceRatio": 0.9997151034028486,
            "avgQualityScore": null
          },
          {
            "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
            "kind": "silent",
            "start": "2026-04-08T08:44:52Z",
            "end": "2026-04-08T10:15:20Z",
            "durationSeconds": 5428,
            "avgSilenceRatio": 0.9997850483926534,
            "avgQualityScore": null
          },
          {
            "stationId": "5ac4fc76-97c7-47ff-8431-64be84f93979",
            "kind": "silent",
            "start": "2026-04-08T10:18:51Z",
            "end": "2026-04-08T11:04:20Z",
            "durationSeconds": 2729,
            "avgSilenceRatio": 1.0000002619213022,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 2,
              "silentDurationSeconds": 21415,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 2,
              "totalDurationSeconds": 21415,
              "degradationRatio": 0.2478587991650324
            },
            "serviceHealth": {
              "weightedBadSeconds": 21412,
              "stationUptimeRatio": 0.7521759230575917,
              "healthScoreRatio": 0.7521759230575917
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 5,
          "silentIssueDurationSeconds": 21412
        }
      },
      {
        "stationId": "88e231cc-deb5-48dd-89a5-c9455e922c9c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "112e45b7-bd75-4475-8d70-c6db9d2fec74",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "09a45b9b-abe6-4fb7-b267-d94ceaa424d5",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775662200000",
            "stationId": "09a45b9b-abe6-4fb7-b267-d94ceaa424d5",
            "durationMs": 1064960,
            "previousSegmentStartTs": 1775660442000,
            "previousSegmentEndTs": 1775660472040,
            "nextSegmentStartTs": 1775661537000,
            "nextSegmentEndTs": 1775661566884,
            "createdAt": "2026-04-08T15:30:03.950Z",
            "id": "af90c07e-bdff-4e3c-80e1-5418cbeebfe7",
            "start": "2026-04-08T15:01:12.040Z",
            "end": "2026-04-08T15:18:57.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775671800000",
            "stationId": "09a45b9b-abe6-4fb7-b267-d94ceaa424d5",
            "durationMs": 53960,
            "previousSegmentStartTs": 1775670969000,
            "previousSegmentEndTs": 1775670999040,
            "nextSegmentStartTs": 1775671053000,
            "nextSegmentEndTs": 1775671082884,
            "createdAt": "2026-04-08T18:10:03.660Z",
            "id": "6aaed1f0-cbc8-4efd-be29-c48fb0684c8c",
            "start": "2026-04-08T17:56:39.040Z",
            "end": "2026-04-08T17:57:33.000Z"
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 2,
              "incidentDurationSeconds": 1118.92,
              "maxIncidentDurationSeconds": 1064.96,
              "meanIncidentDurationSeconds": 559.46,
              "uptimeRatio": 0.9870495368871475,
              "downtimeRatio": 0.012950463112852584
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 1118.92,
              "stationUptimeRatio": 0.9870495368871475,
              "healthScoreRatio": 0.9870495368871475
            }
          },
          "streamGapCount": 2,
          "streamGapDurationSeconds": 1118.92,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "15f719ee-dd3c-4728-b14b-77232342431f",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775662200000",
            "stationId": "15f719ee-dd3c-4728-b14b-77232342431f",
            "durationMs": 1063960,
            "previousSegmentStartTs": 1775660443000,
            "previousSegmentEndTs": 1775660473040,
            "nextSegmentStartTs": 1775661537000,
            "nextSegmentEndTs": 1775661566884,
            "createdAt": "2026-04-08T15:30:04.020Z",
            "id": "bd640a5c-a62d-4c5a-ab3b-f7a63dcac8d8",
            "start": "2026-04-08T15:01:13.040Z",
            "end": "2026-04-08T15:18:57.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775671800000",
            "stationId": "15f719ee-dd3c-4728-b14b-77232342431f",
            "durationMs": 53960,
            "previousSegmentStartTs": 1775670969000,
            "previousSegmentEndTs": 1775670999040,
            "nextSegmentStartTs": 1775671053000,
            "nextSegmentEndTs": 1775671082884,
            "createdAt": "2026-04-08T18:10:03.887Z",
            "id": "c59fc647-6794-4e04-8665-095eeacd7e56",
            "start": "2026-04-08T17:56:39.040Z",
            "end": "2026-04-08T17:57:33.000Z"
          }
        ],
        "audioQualityIssues": [
          {
            "stationId": "15f719ee-dd3c-4728-b14b-77232342431f",
            "kind": "silent",
            "start": "2026-04-08T15:18:57Z",
            "end": "2026-04-08T15:25:57Z",
            "durationSeconds": 420,
            "avgSilenceRatio": 0.9932166700197138,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 2,
              "incidentDurationSeconds": 1117.92,
              "maxIncidentDurationSeconds": 1063.96,
              "meanIncidentDurationSeconds": 558.96,
              "uptimeRatio": 0.9870611109613554,
              "downtimeRatio": 0.01293888903864455
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 420,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 420,
              "degradationRatio": 0.004861111167373972
            },
            "serviceHealth": {
              "weightedBadSeconds": 1537.92,
              "stationUptimeRatio": 0.9821999997939814,
              "healthScoreRatio": 0.9821999997939814
            }
          },
          "streamGapCount": 2,
          "streamGapDurationSeconds": 1117.92,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 1,
          "silentIssueDurationSeconds": 420
        }
      },
      {
        "stationId": "1660eafe-70d8-42ab-8a57-8cfa5ed290c0",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "1660eafe-70d8-42ab-8a57-8cfa5ed290c0",
            "kind": "silent",
            "start": "2026-04-08T04:02:47Z",
            "end": "2026-04-08T04:11:17Z",
            "durationSeconds": 510,
            "avgSilenceRatio": 0.9999837966534699,
            "avgQualityScore": null
          },
          {
            "stationId": "1660eafe-70d8-42ab-8a57-8cfa5ed290c0",
            "kind": "silent",
            "start": "2026-04-08T12:31:58Z",
            "end": "2026-04-08T12:44:28Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "1660eafe-70d8-42ab-8a57-8cfa5ed290c0",
            "kind": "silent",
            "start": "2026-04-08T12:44:29Z",
            "end": "2026-04-08T12:56:59Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9975035777326966,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 2,
              "silentDurationSeconds": 2011,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 2,
              "totalDurationSeconds": 2011,
              "degradationRatio": 0.0232754632323549
            },
            "serviceHealth": {
              "weightedBadSeconds": 2010,
              "stationUptimeRatio": 0.9767361108418531,
              "healthScoreRatio": 0.9767361108418531
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 3,
          "silentIssueDurationSeconds": 2010
        }
      },
      {
        "stationId": "1712b992-cdc0-4d31-81b3-cad376d90290",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775535600000",
            "stationId": "1712b992-cdc0-4d31-81b3-cad376d90290",
            "durationMs": null,
            "previousSegmentStartTs": 1775535183000,
            "previousSegmentEndTs": 1775535213040,
            "nextSegmentStartTs": null,
            "nextSegmentEndTs": null,
            "createdAt": "2026-04-07T04:20:05.739Z",
            "id": "f17ec168-594e-46f1-a5ef-97068c4cb6f9",
            "start": "2026-04-07T04:13:33.040Z",
            "end": null
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 1,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "9dd15485-dc2b-458e-9036-f6674d03f8c3",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "90eaa83a-2e19-451d-8fe4-cfc5c5f94e5e",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "90eaa83a-2e19-451d-8fe4-cfc5c5f94e5e",
            "kind": "silent",
            "start": "2026-04-08T03:59:31Z",
            "end": "2026-04-08T04:11:01Z",
            "durationSeconds": 690,
            "avgSilenceRatio": 1.0000005071596632,
            "avgQualityScore": null
          },
          {
            "stationId": "90eaa83a-2e19-451d-8fe4-cfc5c5f94e5e",
            "kind": "silent",
            "start": "2026-04-08T11:51:26Z",
            "end": "2026-04-08T11:58:56Z",
            "durationSeconds": 450,
            "avgSilenceRatio": 0.9872827445198922,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 2,
              "silentDurationSeconds": 1140,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 2,
              "totalDurationSeconds": 1140,
              "degradationRatio": 0.013194444597157923
            },
            "serviceHealth": {
              "weightedBadSeconds": 1140,
              "stationUptimeRatio": 0.9868055554028421,
              "healthScoreRatio": 0.9868055554028421
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 2,
          "silentIssueDurationSeconds": 1140
        }
      },
      {
        "stationId": "45607b72-f8e6-43db-960a-31afa4686a2c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "63eb7fbc-7969-41ee-b6d9-bc61ffe60467",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "954ed8b4-3811-4e01-82b4-6ee102ec1c4e",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "00350dae-1212-4a06-a9b6-38507b426872",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "7e25d718-1b35-4796-ab8f-64a462ca36f8",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0a25fdd4-c75e-44f7-b824-814e3da1a76b",
        "streamGaps": [
          {
            "jobId": "43103",
            "stationId": "0a25fdd4-c75e-44f7-b824-814e3da1a76b",
            "durationMs": null,
            "previousSegmentStartTs": 1759426220000,
            "previousSegmentEndTs": 1759426250040,
            "nextSegmentStartTs": null,
            "nextSegmentEndTs": null,
            "createdAt": "2026-04-05T23:06:29.059Z",
            "id": "b06c7cb2-bf14-4aaa-a4b3-27a27797fac4",
            "start": "2025-10-02T17:30:50.040Z",
            "end": null
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 1,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
            "kind": "silent",
            "start": "2026-04-08T06:05:37Z",
            "end": "2026-04-08T06:15:37Z",
            "durationSeconds": 600,
            "avgSilenceRatio": 0.99999941757232,
            "avgQualityScore": null
          },
          {
            "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
            "kind": "silent",
            "start": "2026-04-08T06:15:38Z",
            "end": "2026-04-08T06:28:08Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
            "kind": "silent",
            "start": "2026-04-08T06:28:09Z",
            "end": "2026-04-08T06:40:39Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
            "kind": "silent",
            "start": "2026-04-08T06:40:40Z",
            "end": "2026-04-08T06:53:10Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995006836474,
            "avgQualityScore": null
          },
          {
            "stationId": "829954a1-c6b6-4e9d-9d66-9f2bebd9ae0e",
            "kind": "silent",
            "start": "2026-04-08T06:53:11Z",
            "end": "2026-04-08T07:05:41Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999994009062192,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 3604,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 3604,
              "degradationRatio": 0.04171296344575189
            },
            "serviceHealth": {
              "weightedBadSeconds": 3600,
              "stationUptimeRatio": 0.9583333328510802,
              "healthScoreRatio": 0.9583333328510802
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 5,
          "silentIssueDurationSeconds": 3600
        }
      },
      {
        "stationId": "6b2b62f7-32f6-4400-a47e-9a4f8d4072a5",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775620200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775620061000,
            "previousSegmentEndTs": 1775620091040,
            "nextSegmentStartTs": 1775620121000,
            "nextSegmentEndTs": 1775620128889,
            "createdAt": "2026-04-08T03:50:05.248Z",
            "id": "dc50909e-f8bb-42e7-945a-d33802bbd467",
            "start": "2026-04-08T03:48:11.040Z",
            "end": "2026-04-08T03:48:41.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775622000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775621849000,
            "previousSegmentEndTs": 1775621879040,
            "nextSegmentStartTs": 1775621909000,
            "nextSegmentEndTs": 1775621916915,
            "createdAt": "2026-04-08T04:20:05.110Z",
            "id": "ed3c1d95-12c1-4919-80eb-f1786257779e",
            "start": "2026-04-08T04:17:59.040Z",
            "end": "2026-04-08T04:18:29.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775622600000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 5960,
            "previousSegmentStartTs": 1775622269000,
            "previousSegmentEndTs": 1775622299040,
            "nextSegmentStartTs": 1775622305000,
            "nextSegmentEndTs": 1775622335040,
            "createdAt": "2026-04-08T04:30:04.764Z",
            "id": "0d4b18ac-24aa-4f4c-8f95-f98803669193",
            "start": "2026-04-08T04:24:59.040Z",
            "end": "2026-04-08T04:25:05.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775623800000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 31960,
            "previousSegmentStartTs": 1775623095000,
            "previousSegmentEndTs": 1775623125040,
            "nextSegmentStartTs": 1775623157000,
            "nextSegmentEndTs": 1775623161022,
            "createdAt": "2026-04-08T04:50:05.059Z",
            "id": "5a5f22ec-c98b-4b2a-b681-083b886579a7",
            "start": "2026-04-08T04:38:45.040Z",
            "end": "2026-04-08T04:39:17.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775627400000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775627215000,
            "previousSegmentEndTs": 1775627245040,
            "nextSegmentStartTs": 1775627275000,
            "nextSegmentEndTs": 1775627300887,
            "createdAt": "2026-04-08T05:50:06.182Z",
            "id": "633ff483-09d8-403b-8042-602c35369f67",
            "start": "2026-04-08T05:47:25.040Z",
            "end": "2026-04-08T05:47:55.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775638200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 9960,
            "previousSegmentStartTs": 1775637506000,
            "previousSegmentEndTs": 1775637536040,
            "nextSegmentStartTs": 1775637546000,
            "nextSegmentEndTs": 1775637576040,
            "createdAt": "2026-04-08T08:50:05.548Z",
            "id": "88e0a678-3e5f-436a-8a73-eb15f1a28ac4",
            "start": "2026-04-08T08:38:56.040Z",
            "end": "2026-04-08T08:39:06.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775647200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 7960,
            "previousSegmentStartTs": 1775646708000,
            "previousSegmentEndTs": 1775646738040,
            "nextSegmentStartTs": 1775646746000,
            "nextSegmentEndTs": 1775646776040,
            "createdAt": "2026-04-08T11:20:08.989Z",
            "id": "aaaffff0-cb5f-404a-b854-893130147a04",
            "start": "2026-04-08T11:12:18.040Z",
            "end": "2026-04-08T11:12:26.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775652600000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775652394000,
            "previousSegmentEndTs": 1775652424040,
            "nextSegmentStartTs": 1775652454000,
            "nextSegmentEndTs": 1775652459929,
            "createdAt": "2026-04-08T12:50:04.836Z",
            "id": "79d7986d-dcab-471a-9b3c-7dfe963b8dc9",
            "start": "2026-04-08T12:47:04.040Z",
            "end": "2026-04-08T12:47:34.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775656200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775655978000,
            "previousSegmentEndTs": 1775656008040,
            "nextSegmentStartTs": 1775656038000,
            "nextSegmentEndTs": 1775656049885,
            "createdAt": "2026-04-08T13:50:05.362Z",
            "id": "722cf134-e99f-4a16-a0a1-d4a22d122714",
            "start": "2026-04-08T13:46:48.040Z",
            "end": "2026-04-08T13:47:18.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775657400000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 11960,
            "previousSegmentStartTs": 1775656918000,
            "previousSegmentEndTs": 1775656948040,
            "nextSegmentStartTs": 1775656960000,
            "nextSegmentEndTs": 1775656972120,
            "createdAt": "2026-04-08T14:10:06.298Z",
            "id": "165a1547-afac-4b29-8b7e-faa71b7f247d",
            "start": "2026-04-08T14:02:28.040Z",
            "end": "2026-04-08T14:02:40.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775658000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775657702000,
            "previousSegmentEndTs": 1775657732040,
            "nextSegmentStartTs": 1775657762000,
            "nextSegmentEndTs": 1775657765944,
            "createdAt": "2026-04-08T14:20:04.859Z",
            "id": "698cbed0-f797-43e4-80ce-e7b1bb4bf155",
            "start": "2026-04-08T14:15:32.040Z",
            "end": "2026-04-08T14:16:02.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775658000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 11960,
            "previousSegmentStartTs": 1775657804000,
            "previousSegmentEndTs": 1775657834040,
            "nextSegmentStartTs": 1775657846000,
            "nextSegmentEndTs": 1775657876040,
            "createdAt": "2026-04-08T14:20:04.863Z",
            "id": "8de4def7-6538-4343-813b-fb7990aecb7e",
            "start": "2026-04-08T14:17:14.040Z",
            "end": "2026-04-08T14:17:26.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775659200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 30960,
            "previousSegmentStartTs": 1775658522000,
            "previousSegmentEndTs": 1775658552040,
            "nextSegmentStartTs": 1775658583000,
            "nextSegmentEndTs": 1775658588720,
            "createdAt": "2026-04-08T14:40:08.466Z",
            "id": "b36714ce-4f35-49de-82a5-d2d014f213af",
            "start": "2026-04-08T14:29:12.040Z",
            "end": "2026-04-08T14:29:43.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775661000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775660593000,
            "previousSegmentEndTs": 1775660623040,
            "nextSegmentStartTs": 1775660653000,
            "nextSegmentEndTs": 1775660671024,
            "createdAt": "2026-04-08T15:10:05.760Z",
            "id": "ff427cfa-6182-43e8-939a-a74501ab9557",
            "start": "2026-04-08T15:03:43.040Z",
            "end": "2026-04-08T15:04:13.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775661000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775660683000,
            "previousSegmentEndTs": 1775660713040,
            "nextSegmentStartTs": 1775660743000,
            "nextSegmentEndTs": 1775660746970,
            "createdAt": "2026-04-08T15:10:05.763Z",
            "id": "1aa5af4a-2efc-4c52-b22a-da92f16944e6",
            "start": "2026-04-08T15:05:13.040Z",
            "end": "2026-04-08T15:05:43.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775662200000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 31960,
            "previousSegmentStartTs": 1775661793000,
            "previousSegmentEndTs": 1775661823040,
            "nextSegmentStartTs": 1775661855000,
            "nextSegmentEndTs": 1775661862810,
            "createdAt": "2026-04-08T15:30:04.767Z",
            "id": "fad37d51-f6e4-4352-bcf1-85d2cce32e92",
            "start": "2026-04-08T15:23:43.040Z",
            "end": "2026-04-08T15:24:15.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775664000000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775663335000,
            "previousSegmentEndTs": 1775663365040,
            "nextSegmentStartTs": 1775663395000,
            "nextSegmentEndTs": 1775663402941,
            "createdAt": "2026-04-08T16:00:05.315Z",
            "id": "715668b2-6c7b-4e36-b2ce-0aafb60e23f9",
            "start": "2026-04-08T15:49:25.040Z",
            "end": "2026-04-08T15:49:55.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775669400000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775668715000,
            "previousSegmentEndTs": 1775668745040,
            "nextSegmentStartTs": 1775668775000,
            "nextSegmentEndTs": 1775668782967,
            "createdAt": "2026-04-08T17:30:04.865Z",
            "id": "446ae815-2a91-4463-9b21-68bc2a74a93c",
            "start": "2026-04-08T17:19:05.040Z",
            "end": "2026-04-08T17:19:35.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775671800000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775671483000,
            "previousSegmentEndTs": 1775671513040,
            "nextSegmentStartTs": 1775671543000,
            "nextSegmentEndTs": 1775671550915,
            "createdAt": "2026-04-08T18:10:04.933Z",
            "id": "f0b702da-a45a-47a6-b58c-a16982d388d2",
            "start": "2026-04-08T18:05:13.040Z",
            "end": "2026-04-08T18:05:43.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775672400000",
            "stationId": "7e6cd7a1-04b2-4d60-ace6-db3400f8bc2e",
            "durationMs": 29960,
            "previousSegmentStartTs": 1775672243000,
            "previousSegmentEndTs": 1775672273040,
            "nextSegmentStartTs": 1775672303000,
            "nextSegmentEndTs": 1775672310915,
            "createdAt": "2026-04-08T18:20:05.066Z",
            "id": "1f15e462-7b64-455b-8ce1-096b86060f81",
            "start": "2026-04-08T18:17:53.040Z",
            "end": "2026-04-08T18:18:23.000Z"
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 20,
              "incidentDurationSeconds": 502.1999999999999,
              "maxIncidentDurationSeconds": 31.96,
              "meanIncidentDurationSeconds": 25.109999999999992,
              "uptimeRatio": 0.9941874999327257,
              "downtimeRatio": 0.005812500067274305
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 502.1999999999999,
              "stationUptimeRatio": 0.9941874999327257,
              "healthScoreRatio": 0.9941874999327257
            }
          },
          "streamGapCount": 20,
          "streamGapDurationSeconds": 502.2,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "6f005d02-a104-4c07-b8d4-961d1d853aa2",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "bc8f11ab-d90c-4608-86fe-e3b0d60c5dc6",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "f81022b3-c233-462e-9b76-60bac92a4d01",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "517193e9-b611-4988-aab5-f476af178ae6",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "4436d1ea-ebc6-46c2-9b3c-412d37452163",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "197923e4-e094-4789-b032-95ce33230c60",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "b01411c7-fcd4-4ab2-9ae2-a753e63c2a77",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "ddd952d0-2511-4a2c-8a37-0d58ea6dc0c6",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "6070c7cd-40eb-4980-8cb7-67f0193bd480",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "11c173c5-e9f5-447b-aa26-6fa2f2392d8e",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d12d5514-5c13-46d8-9da6-8077d9930b9c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "e6592d8c-e789-4ef2-9a20-bd41ec3d88f2",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "eabe3234-5036-4f0b-a1df-1d014f1a7fe4",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "71d7f5d0-9e14-443c-91b0-e0b31fc7b29c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "e84ef14e-e3c3-437f-a64c-531d82b262f8",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "7cd766b9-2f9d-456a-a25b-d4231afad1ce",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "61f3d8a0-286c-4645-8b14-8620116f6808",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "61f3d8a0-286c-4645-8b14-8620116f6808",
            "kind": "silent",
            "start": "2026-04-08T11:59:39Z",
            "end": "2026-04-08T12:05:09Z",
            "durationSeconds": 330,
            "avgSilenceRatio": 0.9634178585199398,
            "avgQualityScore": null
          },
          {
            "stationId": "61f3d8a0-286c-4645-8b14-8620116f6808",
            "kind": "silent",
            "start": "2026-04-08T12:05:10Z",
            "end": "2026-04-08T12:16:40Z",
            "durationSeconds": 690,
            "avgSilenceRatio": 0.9943147659290468,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 1021,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 1021,
              "degradationRatio": 0.011817129766401965
            },
            "serviceHealth": {
              "weightedBadSeconds": 1020,
              "stationUptimeRatio": 0.9881944443078061,
              "healthScoreRatio": 0.9881944443078061
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 2,
          "silentIssueDurationSeconds": 1020
        }
      },
      {
        "stationId": "10e19537-7f15-4893-a391-2d375aa8acb5",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "cac8937d-efff-4395-8a69-f42ff538fe26",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0830accd-339d-43ec-a399-f880f1b59bbc",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "e291db92-ec09-4b0f-b12b-3585d210ff45",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "764d89e5-501e-40b4-940b-6a14f330dc81",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "b948f433-5648-4eb0-811f-8b88d968c640",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0cd5a15a-4f03-4b6d-93b8-636822fee99c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "4f92e971-ce03-47b0-9edc-4171c2087687",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0184acf2-4325-4066-a7da-2f2add4c7c2b",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d8796c12-74bd-468c-b8d1-69a3d7588ce3",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "ab9eeb03-84cb-455f-a3d2-941572aa521b",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d40cf229-fe05-4ea1-888a-084b81cef618",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "86693a78-4546-4f5a-97cf-26976d1d9644",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "99991d50-0299-4b2c-b39e-173382c497fc",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "92115aa7-9681-4343-b039-05158ba80a30",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d797fa66-a853-42a5-b2d1-572c0aab1303",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "ad94077d-651f-4e07-9fe4-a57588e81434",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "05c9865e-2f70-4121-9e58-42c0c6d390b7",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "f3c7e78f-aee2-47bc-b152-e982a7eaf9b2",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "04ba892b-58a6-4f2a-ad1f-69771c647a80",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d7330340-669b-4b18-b7ce-05fe1e9a3fdc",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "9a2a8c10-4ddd-48b1-8623-7a7bd56fb1d2",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "ff96cadf-007e-4053-911e-f3d2484b6579",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "e7837317-8314-4c38-bd4b-8f263f5545cd",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "27799eab-464d-40cf-ac4d-157a73684ab4",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "f4c3ce17-a186-46fb-bbe1-81257f9c2b6a",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
            "kind": "silent",
            "start": "2026-04-08T06:01:07Z",
            "end": "2026-04-08T06:09:37Z",
            "durationSeconds": 510,
            "avgSilenceRatio": 0.9807047701460964,
            "avgQualityScore": null
          },
          {
            "stationId": "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
            "kind": "silent",
            "start": "2026-04-08T11:30:33Z",
            "end": "2026-04-08T11:39:03Z",
            "durationSeconds": 510,
            "avgSilenceRatio": 0.9999995106021954,
            "avgQualityScore": null
          },
          {
            "stationId": "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
            "kind": "silent",
            "start": "2026-04-08T11:39:04Z",
            "end": "2026-04-08T11:51:34Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.999999334243478,
            "avgQualityScore": null
          },
          {
            "stationId": "56d6ad9b-1235-446f-bd39-e95a90f40ba9",
            "kind": "silent",
            "start": "2026-04-08T11:51:35Z",
            "end": "2026-04-08T11:59:05Z",
            "durationSeconds": 450,
            "avgSilenceRatio": 0.9999995008286573,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 2,
              "silentDurationSeconds": 2222,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 2,
              "totalDurationSeconds": 2222,
              "degradationRatio": 0.02571759289024992
            },
            "serviceHealth": {
              "weightedBadSeconds": 2220,
              "stationUptimeRatio": 0.9743055552581662,
              "healthScoreRatio": 0.9743055552581662
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 4,
          "silentIssueDurationSeconds": 2220
        }
      },
      {
        "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T06:01:37Z",
            "end": "2026-04-08T06:14:07Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9997989406131328,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T06:14:08Z",
            "end": "2026-04-08T06:26:38Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T06:26:39Z",
            "end": "2026-04-08T06:39:09Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T06:39:10Z",
            "end": "2026-04-08T06:51:40Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T06:51:41Z",
            "end": "2026-04-08T07:04:11Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T07:04:12Z",
            "end": "2026-04-08T07:16:42Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995006836474,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T07:16:43Z",
            "end": "2026-04-08T07:29:13Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T07:29:14Z",
            "end": "2026-04-08T07:41:44Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T07:41:45Z",
            "end": "2026-04-08T07:54:15Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T07:54:16Z",
            "end": "2026-04-08T08:06:46Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995006836474,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T08:06:47Z",
            "end": "2026-04-08T08:19:17Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T08:19:18Z",
            "end": "2026-04-08T08:31:48Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T08:31:49Z",
            "end": "2026-04-08T08:44:19Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T08:44:20Z",
            "end": "2026-04-08T08:56:50Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T08:56:51Z",
            "end": "2026-04-08T09:09:21Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995006836474,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T09:09:22Z",
            "end": "2026-04-08T09:21:52Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T09:21:53Z",
            "end": "2026-04-08T09:34:23Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T09:34:24Z",
            "end": "2026-04-08T09:46:54Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T09:46:55Z",
            "end": "2026-04-08T09:59:25Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.999999334243478,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T09:59:26Z",
            "end": "2026-04-08T10:11:56Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T10:11:57Z",
            "end": "2026-04-08T10:24:27Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T10:24:28Z",
            "end": "2026-04-08T10:36:58Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T10:36:59Z",
            "end": "2026-04-08T10:49:29Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T10:49:30Z",
            "end": "2026-04-08T11:02:00Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995006836474,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T11:02:01Z",
            "end": "2026-04-08T11:14:31Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T11:14:32Z",
            "end": "2026-04-08T11:27:02Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999993676185178,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T11:27:03Z",
            "end": "2026-04-08T11:39:33Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999960720945218,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T11:39:34Z",
            "end": "2026-04-08T11:52:04Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.9999995340586871,
            "avgQualityScore": null
          },
          {
            "stationId": "2b1df331-160d-4948-b26e-7d3798c79559",
            "kind": "silent",
            "start": "2026-04-08T11:52:05Z",
            "end": "2026-04-08T11:58:35Z",
            "durationSeconds": 390,
            "avgSilenceRatio": 0.9788840030809036,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 21418,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 21418,
              "degradationRatio": 0.2478935213876565
            },
            "serviceHealth": {
              "weightedBadSeconds": 21390,
              "stationUptimeRatio": 0.7524305526901685,
              "healthScoreRatio": 0.7524305526901685
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 29,
          "silentIssueDurationSeconds": 21390
        }
      },
      {
        "stationId": "677ca85a-33e6-4cc4-a004-88ee741dd4ab",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "6031e0d1-fa7d-4ff5-9931-5d305a530e5c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "645a0be6-a451-4932-bad1-0e27ffb01f42",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "fce78082-619b-4fa0-b01b-e63da0cacf3e",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "fce78082-619b-4fa0-b01b-e63da0cacf3e",
            "kind": "silent",
            "start": "2026-04-08T06:05:29Z",
            "end": "2026-04-08T06:14:59Z",
            "durationSeconds": 570,
            "avgSilenceRatio": 0.9918994996376916,
            "avgQualityScore": null
          },
          {
            "stationId": "fce78082-619b-4fa0-b01b-e63da0cacf3e",
            "kind": "silent",
            "start": "2026-04-08T06:15:00Z",
            "end": "2026-04-08T06:27:30Z",
            "durationSeconds": 750,
            "avgSilenceRatio": 0.999999334243478,
            "avgQualityScore": null
          },
          {
            "stationId": "fce78082-619b-4fa0-b01b-e63da0cacf3e",
            "kind": "silent",
            "start": "2026-04-08T06:27:31Z",
            "end": "2026-04-08T06:39:31Z",
            "durationSeconds": 720,
            "avgSilenceRatio": 0.9999996186693986,
            "avgQualityScore": null
          },
          {
            "stationId": "fce78082-619b-4fa0-b01b-e63da0cacf3e",
            "kind": "silent",
            "start": "2026-04-08T06:39:32Z",
            "end": "2026-04-08T06:50:32Z",
            "durationSeconds": 660,
            "avgSilenceRatio": 0.9999181495023115,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 2703,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 2703,
              "degradationRatio": 0.03128472258431392
            },
            "serviceHealth": {
              "weightedBadSeconds": 2700,
              "stationUptimeRatio": 0.9687499996383102,
              "healthScoreRatio": 0.9687499996383102
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 4,
          "silentIssueDurationSeconds": 2700
        }
      },
      {
        "stationId": "7acfa578-c92a-4cc1-b8dd-09856ca90e6d",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "192cd181-ae2d-461a-8d2b-8844fe1ef090",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "42eff9b9-2864-48cc-bc82-5a72cc67d619",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "4aa656e2-fd41-4aff-a6d7-59713f288582",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "1098631f-11ba-41b6-b5ff-7dcc3f10a5b8",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "d1b14752-cefc-4079-98f1-674d3e14e80f",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "e9161ab9-f457-405b-a272-9eca7d6c1d9a",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0bea368f-d27a-4c63-a656-8598414b7bd1",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "c8c3be17-339e-4563-914f-7cd64817d9f4",
        "streamGaps": [],
        "audioQualityIssues": [
          {
            "stationId": "c8c3be17-339e-4563-914f-7cd64817d9f4",
            "kind": "silent",
            "start": "2026-04-08T12:02:47Z",
            "end": "2026-04-08T12:12:47Z",
            "durationSeconds": 600,
            "avgSilenceRatio": 0.9999790701021659,
            "avgQualityScore": null
          }
        ],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 1,
              "silentDurationSeconds": 600,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 1,
              "totalDurationSeconds": 600,
              "degradationRatio": 0.00694444452481996
            },
            "serviceHealth": {
              "weightedBadSeconds": 600,
              "stationUptimeRatio": 0.99305555547518,
              "healthScoreRatio": 0.99305555547518
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 1,
          "silentIssueDurationSeconds": 600
        }
      },
      {
        "stationId": "37cd7cdc-ec7c-4a8f-985a-0c4dc5b9084a",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "019c0a25-b502-47c1-86a5-5be9435d8eef",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "2e40c74f-3f86-4ab7-bd8c-4db495531396",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "9aca0b22-eebc-4c6c-a171-d6209be0fce5",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "09ebb340-7007-4ccf-9742-3d9dca59c431",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "bbd64e88-05da-4f39-a1a6-9a90932fb052",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "948ed131-ea21-4369-8d87-b17c314de7c3",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "546ddf5d-9db2-4ff5-a5e2-ecd0da990959",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "0ced609a-bcfd-40ca-80dc-37b5f7726caf",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "284f240c-e40d-44f7-a703-8d538cfb9af8",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "25033d4b-92bf-40b1-994b-fcf06983fc97",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775502000000",
            "stationId": "25033d4b-92bf-40b1-994b-fcf06983fc97",
            "durationMs": null,
            "previousSegmentStartTs": 1775501865000,
            "previousSegmentEndTs": 1775501895040,
            "nextSegmentStartTs": null,
            "nextSegmentEndTs": null,
            "createdAt": "2026-04-06T19:00:10.133Z",
            "id": "bac3b1f1-fcf4-4882-a0cd-7e0194a6748e",
            "start": "2026-04-06T18:58:15.040Z",
            "end": null
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 1,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "c9f4aff8-55f0-4f7e-942b-e5bc6b798c26",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "298f9893-4684-4d7a-b377-26054de56458",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "ad59d52e-991b-4b01-8d97-dec9a1c0c84b",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "01e00cc6-95d2-4ef8-b343-6a3d1c1d9cb6",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "cf56afae-a35f-4a57-a01a-80144694981c",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "f722157e-bac3-4bbd-91d4-05cd0fcfe725",
        "streamGaps": [
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775634000000",
            "stationId": "f722157e-bac3-4bbd-91d4-05cd0fcfe725",
            "durationMs": 420594,
            "previousSegmentStartTs": 1775632986000,
            "previousSegmentEndTs": 1775633014406,
            "nextSegmentStartTs": 1775633435000,
            "nextSegmentEndTs": 1775633464104,
            "createdAt": "2026-04-08T07:40:09.704Z",
            "id": "d955efa7-d86d-4eba-95fb-df20bd7ed0f3",
            "start": "2026-04-08T07:23:34.406Z",
            "end": "2026-04-08T07:30:35.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775634000000",
            "stationId": "f722157e-bac3-4bbd-91d4-05cd0fcfe725",
            "durationMs": 290900,
            "previousSegmentStartTs": 1775633494000,
            "previousSegmentEndTs": 1775633511100,
            "nextSegmentStartTs": 1775633802000,
            "nextSegmentEndTs": 1775633832573,
            "createdAt": "2026-04-08T07:40:09.708Z",
            "id": "a945b503-e43b-4982-b543-0675f27e7f10",
            "start": "2026-04-08T07:31:51.100Z",
            "end": "2026-04-08T07:36:42.000Z"
          },
          {
            "jobId": "repeat:2faf0232aa8507cc9493cf37b89a67b4:1775634600000",
            "stationId": "f722157e-bac3-4bbd-91d4-05cd0fcfe725",
            "durationMs": 200177,
            "previousSegmentStartTs": 1775634012000,
            "previousSegmentEndTs": 1775634021823,
            "nextSegmentStartTs": 1775634222000,
            "nextSegmentEndTs": 1775634253973,
            "createdAt": "2026-04-08T07:50:14.463Z",
            "id": "c01fff66-210a-44bc-b029-e6cd1acab0f7",
            "start": "2026-04-08T07:40:21.823Z",
            "end": "2026-04-08T07:43:42.000Z"
          }
        ],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 3,
              "incidentDurationSeconds": 911.6709999999999,
              "maxIncidentDurationSeconds": 420.594,
              "meanIncidentDurationSeconds": 303.89033333333333,
              "uptimeRatio": 0.9894482521926881,
              "downtimeRatio": 0.010551747807311896
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 911.6709999999999,
              "stationUptimeRatio": 0.9894482521926881,
              "healthScoreRatio": 0.9894482521926881
            }
          },
          "streamGapCount": 3,
          "streamGapDurationSeconds": 911.671,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      },
      {
        "stationId": "a01ad234-9b34-460b-9ce9-268423e5d4a9",
        "streamGaps": [],
        "audioQualityIssues": [],
        "stats": {
          "kpis": {
            "continuity": {
              "incidentCount": 0,
              "incidentDurationSeconds": 0,
              "maxIncidentDurationSeconds": 0,
              "meanIncidentDurationSeconds": 0,
              "uptimeRatio": 1,
              "downtimeRatio": 0
            },
            "quality": {
              "silentIncidentCount": 0,
              "silentDurationSeconds": 0,
              "poorQualityIncidentCount": 0,
              "poorQualityDurationSeconds": 0,
              "totalIncidentCount": 0,
              "totalDurationSeconds": 0,
              "degradationRatio": 0
            },
            "serviceHealth": {
              "weightedBadSeconds": 0,
              "stationUptimeRatio": 1,
              "healthScoreRatio": 1
            }
          },
          "streamGapCount": 0,
          "streamGapDurationSeconds": 0,
          "poorQualityIssueCount": 0,
          "poorQualityIssueDurationSeconds": 0,
          "silentIssueCount": 0,
          "silentIssueDurationSeconds": 0
        }
      }
    ]
  }
}
